export const formatPrice = (price) => parseFloat(price).toFixed(2);

export const formatDateStr = (date) => `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;

/**
 * Formats a price with the correct currency symbol and optionally adds currency code for CAD
 * @param {string} formattedPrice - The formatted price from backend (e.g., "$123.45")
 * @param {string} currencySymbol - The correct currency symbol (e.g., "$", "€")
 * @param {string} currency - The currency code (e.g., "CAD", "USD", "EUR")
 * @param {boolean} appendCurrencyCode - Whether to append currency code for CAD (default: false)
 * @returns {string} - The properly formatted price
 */
export const formatPriceWithCurrency = (formattedPrice, currencySymbol, currency, appendCurrencyCode = false) => {
  // If no price or currency symbol provided, return original
  if (!formattedPrice || !currencySymbol) {
    return formattedPrice || '';
  }

  // Replace the generic "$" with the proper currency symbol first
  let result = formattedPrice;
  if (formattedPrice.includes('$') && !formattedPrice.includes(currencySymbol)) {
    result = formattedPrice.replace('$', currencySymbol);
  }

  // Special handling for CAD: append "CAD" to the price when requested
  if (currency === 'CAD' && appendCurrencyCode && !result.includes('CAD')) {
    return `${result} CAD`;
  }

  return result;
};
